import React, {useEffect, useState} from "react";

const AddToFavorites = ({ id }) => {

    let[favorite, setFavorite] = useState(false);

    function addToFavorites() {
        const favorites = JSON.parse(localStorage.getItem("favorites")) || [];
        if (!favorites.includes(id)) {
            favorites.push(id);
            localStorage.setItem("favorites", JSON.stringify(favorites));
        }
        setFavorite(true);
    }

    const handleClick = () => {
        if (favorite) {
            removeFromFavorites();
        } else {
            addToFavorites();
        }
    };

    const removeFromFavorites = () => {
        const favorites = JSON.parse(localStorage.getItem("favorites")) || [];
        const newFavorites = favorites.filter((favorite) => favorite !== id);
        localStorage.setItem("favorites", JSON.stringify(newFavorites));
        setFavorite(false);
    }

    const isFavorite = () => {
        const favorites = JSON.parse(localStorage.getItem("favorites")) || [];
        return favorites.includes(id);
    }

    function getIcon(id) {
        if (isFavorite(id)) {
            return <i className="icon-heart-filled text-12"/>;
        } else {
            return <i className="icon-heart text-12"/>;
        }
    }

    return (
    <div className="cardImage__wishlist">
        <button
            className="button -blue-1 bg-white size-30 rounded-full shadow-2"
            onClick={handleClick}
            aria-label={isFavorite(id) ? "Usuń z ulubionych" : "Dodaj do ulubionych"}
        >
            {getIcon(id)}
        </button>
    </div>
  );
};

export default AddToFavorites;